import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
@Component({
  selector: "app-getincar",
  templateUrl: "./getincar.component.html",
  styleUrls: ["./getincar.component.css"],
})
export class GetincarComponent implements OnInit {
  constructor(private router: Router) {}
  slowAlert() {
    alert(
      "this is the wrong choice, you will be given the opportunity to retry after you see the results of this choice.",
    );
  }

  ngOnInit() {
    //  { setTimeout(function () {
    //    //will redirect to your blog page (an ex: blog.html)
    // }, 3000);

    this.slowAlert();
    window.location.href =
      "https://csec-and-human-trafficking-prevention-ct6fxgqhf.vercel.app/duringcar";
    //  { var snd1  = new Audio();
    //   var src1  = document.createElement("source");
    //   src1.type = "audio/mp3";
    //   src1.src  = "audio/../../assets/amycar.mp3";
    //   snd1.appendChild(src1);

    //   var snd2  = new Audio();
    //   var src2  = document.createElement("source");
    //   src2.type = "audio/wav";
    //   src2.src  = "audio/../../assets/cardooropen.wav";
    //   snd2.appendChild(src2);

    //   snd1.play(); snd2.play(); window.stop()} }}
  }
}



// WEBPACK FOOTER //
// ./src/app/getincar/getincar.component.ts